import React from "react";
import { Modal, Typography } from "@mui/material";
import { useAppSelector } from "../redux/hooks";
import LoadingIndicator from "./misc/LoadingIndicator";

const CIRCULAR_PROGRESS_SIZE = 30;

const CIRCULAR_PROGRESS_FAKE_CONTAINER_STYLE = {
  width: CIRCULAR_PROGRESS_SIZE,
  height: CIRCULAR_PROGRESS_SIZE,
};

function GlobalLoading() {
  const { loadingGlobal } = useAppSelector((state) => ({
    loadingGlobal: state.globalComponents.loadingGlobal,
  }));

  return (
    <Modal
      open={loadingGlobal.open}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
        backgroundColor: "rgba(0,0,0,0.2)",
      }}>
      <div
        role="status"
        aria-live="polite"
        className="mx-4 flex w-auto max-w-lg items-center justify-between gap-6 rounded-card bg-white p-10 shadow-card">
        {loadingGlobal.loadingAlign === "left" ? (
          <LoadingIndicator size={CIRCULAR_PROGRESS_SIZE} />
        ) : (
          <div style={CIRCULAR_PROGRESS_FAKE_CONTAINER_STYLE} />
        )}

        <div>
          {loadingGlobal.title && (
            <Typography variant="h6" className="my-2 font-bold">
              {loadingGlobal.title}
            </Typography>
          )}
          {loadingGlobal.subtitle && (
            <Typography variant="body2" className="my-2 text-muted-dark">
              {loadingGlobal.subtitle}
            </Typography>
          )}
        </div>

        {loadingGlobal.loadingAlign === "right" ? (
          <LoadingIndicator size={CIRCULAR_PROGRESS_SIZE} />
        ) : (
          <div style={CIRCULAR_PROGRESS_FAKE_CONTAINER_STYLE} />
        )}
      </div>
    </Modal>
  );
}

export default GlobalLoading;
